export function TransferCart() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9167 10.416H13.75V27.916H32.9167V10.416Z"
        fill="#148F4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.168 23.75H24.168V21.25H29.168V23.75Z"
        fill="#051D29"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.70452 1.67773L9.51452 5.48607L10.0029 5.9744V28.6177C10.7059 28.8665 11.3443 29.2693 11.8715 29.7968C12.3986 30.3242 12.8012 30.9629 13.0495 31.6661H34.0245L34.5129 32.1544L37.8462 35.4877L35.4895 37.8444L32.6445 34.9994H13.0495C12.7679 35.7962 12.289 36.5086 11.6576 37.0702C11.0261 37.6318 10.2626 38.0242 9.43844 38.2109C8.61424 38.3976 7.75619 38.3723 6.94438 38.1376C6.13256 37.9029 5.39346 37.4663 4.79606 36.8685C4.19866 36.2708 3.76245 35.5315 3.52814 34.7196C3.29382 33.9076 3.26905 33.0496 3.45614 32.2255C3.64322 31.4014 4.03606 30.6381 4.59799 30.0069C5.15991 29.3758 5.8726 28.8972 6.66952 28.6161V7.35607L3.34785 4.03607L5.70452 1.67773Z"
        fill="#051D29"
      />
    </svg>
  );
}
